/* global System */

export default {
  BasicTeaser: () =>
    System.import(/* webpackChunkName: "BasicTeaser" */ './index'),
}
